module.exports = __webpack_public_path__ + "static/media/PetriPienaar.9a1f87a7.jpg";